import React, { useState, useMemo } from 'react';
import NoValue from '../EmptyStates/NoValue';
import { useAssets } from '../../Data/Assets';
import Gallery from './Gallery';
import { classNames } from '../../Services/helpers';

const Preview = ({assetIds, empty, align = 'left'}) => {
    const {assets} = useAssets(assetIds);
    const [isOpen, setIsOpen] = useState(false);

    const theAssets = useMemo(() => {
        if (!assetIds || assetIds.length === 0) {
            return [];
        }

        if (assets) {
            return assets;
        }

        return assetIds.map(id => ({
            id,
            thumbnail: null,
            original: null,
            placeholder: true,
        }));
    }, [assets, assetIds]);

    if (!assetIds || assetIds.length === 0) {
        return empty !== undefined ? empty : <NoValue />;
    }

    const open = (assetId) => {
        // Skip to index?
        setIsOpen(assetId);
    }

    return <>
        <div className={classNames('flex flex-row flex-wrap gap-2', align === 'left' ? 'flex-row' : 'flex-row-reverse')}>
            {theAssets.map(asset => <Thumbnail key={asset.id} {...{open, asset}} />)}
        </div>
        <Gallery {...{isOpen: !!isOpen, setIsOpen, assetIds, initialAssetId: isOpen}} />
    </>;
}

const Thumbnail = ({asset, open}) => {
    return <div className="w-24 h-24 border p-1 rounded-md overflow-hidden hover:border-brand cursor-pointer">
        <img src={asset.thumbnail}
            alt={asset.name}
            className="w-full h-full object-cover rounded-md m-auto"
            onClick={() => open(asset.id)}
        />
    </div>;
}

export default Preview;
